export default __webpack_public_path__ + "static/media/x33-app.51829c6a.svg";